module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_7.79f0df67.png";